import type { ReactNode } from "react";

export interface EmptyStateProps {
  icon?: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
}

export function EmptyState({ icon, title, description, action }: EmptyStateProps) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
        gap: "var(--space-3)",
        padding: "var(--space-8) var(--space-5)",
        color: "var(--color-text-muted)",
      }}
    >
      {icon && <div style={{ fontSize: 40 }}>{icon}</div>}
      <div style={{ fontSize: "var(--font-size-lg)", fontWeight: "var(--font-weight-medium)", color: "var(--color-text)" }}>
        {title}
      </div>
      {description && <div style={{ maxWidth: 360 }}>{description}</div>}
      {action}
    </div>
  );
}
